import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertService } from '@lciapps/lci-core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApplicationInsightsService } from '../application-insights.service';
import { SpinnerService } from '../root/spinner/spinner.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private alertService: AlertService,
    private spinnerService: SpinnerService,
    private insightsService: ApplicationInsightsService
  ) { }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((res: HttpErrorResponse) => {
        this.spinnerService.enableSpinner.next(false);
        let message = '';
        // this.insightsService.trackException(res);
        const status = res.status;
        if (res.error instanceof Error || (res.error instanceof Object && res.error.message)) {
          message = res.error.message;
        } else {
          message = 'An error occurred please contact support'
        }
        if (status === 404) {
          return throwError(res);
        } else if (status === 500) {
          this.alertService.setAlert('An error occurred please contact support');
          console.error(res);
        } else if (status === 403 && res && res.url.toLowerCase().includes('/activities')) {
          this.alertService.setAlert('Temporary Server Error, Please contact support');
          console.error(res);
        } else {
          this.alertService.setAlert(message);
        }
        return throwError(res);
      })
    );
  }
}
